
<kt-splash-screen></kt-splash-screen>
<router-outlet></router-outlet>
 
<ngb-toast (hide)="hideToast()" *ngIf="showToast" [autohide]="true" class="bg-success text-light" delay="2000">
    {{message}}
</ngb-toast>